/* eslint-disable import/no-extraneous-dependencies */
import 'core-js/stable'; // ES Polyfills, include only if needed... around 200k minimized!
import 'regenerator-runtime/runtime';
import 'fetch-ie8';
